'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VariantSelector = exports.ERROR_SELECTED_INVALID_VARIANT = exports.ERROR_INVALID_JSON = exports.ERROR_MULTIPLE_JSON = exports.ERROR_NO_JSON = exports.ERROR_MISSING_SELECTOR = exports.ON_VARIANT_CHANGE = exports.PRODUCT_JSON_SELECTOR = exports.VARIANT_SELECTOR_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _pcSlateTools = require('@process-creative/pc-slate-tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Selectors
var VARIANT_SELECTOR_SELECTOR = exports.VARIANT_SELECTOR_SELECTOR = '[data-variant-selector]'; /*
                                                                                                *  Variant Selector
                                                                                                *    Scripts for the Variant Selector.
                                                                                                *
                                                                                                *
                                                                                                *  Version:
                                                                                                *    1.0.0 - 2020/07/02
                                                                                                */

var PRODUCT_JSON_SELECTOR = exports.PRODUCT_JSON_SELECTOR = '[data-product-json]';

//Events
var ON_VARIANT_CHANGE = exports.ON_VARIANT_CHANGE = 'onVariantChange';

//Errors
var ERROR_MISSING_SELECTOR = exports.ERROR_MISSING_SELECTOR = 'Could find the variant selector element!';
var ERROR_NO_JSON = exports.ERROR_NO_JSON = 'Attempted to load the variant selector, however there is no ' + PRODUCT_JSON_SELECTOR + ' found on the page';
var ERROR_MULTIPLE_JSON = exports.ERROR_MULTIPLE_JSON = 'Variant Selector found multiple ' + PRODUCT_JSON_SELECTOR + ' elements, this could affect it\'s functionality.';
var ERROR_INVALID_JSON = exports.ERROR_INVALID_JSON = 'Variant Selector failed to load Product JSON!';
var ERROR_SELECTED_INVALID_VARIANT = exports.ERROR_SELECTED_INVALID_VARIANT = 'Cannot set this variant, the ID was not found in the product data!';

//Class

var VariantSelector = exports.VariantSelector = function () {
  function VariantSelector(container, data) {
    (0, _classCallCheck3.default)(this, VariantSelector);

    this.container = container;

    this.selector = this.getVariantSelector();
    if (!this.selector || !this.selector.length) throw new Error(ERROR_MISSING_SELECTOR);

    this.currentId = this.selector.val();

    if (!data) {
      //Try and find the product json...
      var jsonElement = [function () {
        return container.find(PRODUCT_JSON_SELECTOR);
      }, function () {
        return container.closest(PRODUCT_JSON_SELECTOR);
      }, function () {
        return $(PRODUCT_JSON_SELECTOR);
      }].find(function (e) {
        var x = e();
        return x && x.length;
      });
      if (!jsonElement) throw new Error(ERROR_NO_JSON);
      jsonElement = jsonElement();
      if (!jsonElement || !jsonElement.length) throw new Error(ERROR_NO_JSON);
      if (jsonElement.length > 1) console.error(ERROR_MULTIPLE_JSON);

      try {
        data = (0, _pcSlateTools.jsonFromjQuery)(jsonElement);
      } catch (e) {
        console.error(ERROR_INVALID_JSON);
        throw e;
      }
    }
    this.data = data;

    this.attachEvents();
  }

  (0, _createClass3.default)(VariantSelector, [{
    key: 'shouldUseEvents',
    value: function shouldUseEvents() {
      return true;
    }
  }, {
    key: 'getVariantSelector',
    value: function getVariantSelector() {
      return this.container.find(VARIANT_SELECTOR_SELECTOR);
    }
  }, {
    key: 'getProductData',
    value: function getProductData() {
      var p = Object.assign({}, this.data);
      p.variants = p.variants.map(function (v) {
        return Object.assign({}, v, {
          product: p
        });
      });
      return p;
    }
  }, {
    key: 'getSelectedVariantId',
    value: function getSelectedVariantId() {
      return this.currentId;
    }
  }, {
    key: 'getVariantData',
    value: function getVariantData(variant) {
      if (!variant) variant = this.getSelectedVariantId();
      var v = this.data.variants.find(function (v) {
        return v.id == variant;
      });
      return Object.assign({}, v, { product: this.getProductData() });
    }
  }, {
    key: 'setVariant',
    value: function setVariant(variantId) {
      //Find the variant that matches this ID
      var variant = this.getVariantData(variantId);
      if (!variant) throw new Error(ERROR_SELECTED_INVALID_VARIANT);

      //Update selector
      var selected = this.getSelectedVariantId();
      if (selected !== null && selected != variantId) this.selector.val(variant.id);

      //Update internal variable
      this.currentId = variant.id;

      //Fire event?
      if (this.shouldUseEvents()) {
        $(document).trigger(ON_VARIANT_CHANGE, [variant, variant.id]);

        //Update the url
        //TODO: This should become part of the product template
        var url = (0, _pcSlateTools.setQueryParams)({ variant: variant.id });
        history.replaceState({ variant: variant, variantId: variantId }, document.title, url);
      }

      this.onVariantChanged(variant, variant.id);
    }
  }, {
    key: 'attachEvents',
    value: function attachEvents() {
      var _this = this;

      this.boundVariantSelected = function (e) {
        return _this.onVariantSelected(e);
      };
      this.container.on('change', VARIANT_SELECTOR_SELECTOR, this.boundVariantSelected);

      if (this.shouldUseEvents()) {
        this.boundVariantChange = function (e, variant, variantId) {
          return _this.onVariantChange(e, variant, variantId);
        };
        $(document).on(ON_VARIANT_CHANGE, this.boundVariantChange);
      }
    }
  }, {
    key: 'detachEvents',
    value: function detachEvents() {
      if (this.boundVariantSelected) this.container.off('change', VARIANT_SELECTOR_SELECTOR, this.boundVariantSelected);
      if (this.boundVariantChange) $(document).off(ON_VARIANT_CHANGE, this.boundVariantChange);
    }
  }, {
    key: 'onVariantSelected',
    value: function onVariantSelected(e) {
      this.setVariant($(e.currentTarget).val());
    }
  }, {
    key: 'onVariantChange',
    value: function onVariantChange(e, variant, variantId) {
      if (variantId == this.getSelectedVariantId()) return;
      this.setVariant(variantId);
    }
  }, {
    key: 'onVariantChanged',
    value: function onVariantChanged(variant, id) {}
  }]);
  return VariantSelector;
}();